/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Not_Found_HeadingInputs */

const sv_page_not_found_heading = /** @type {(inputs: Page_Not_Found_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidan kunde inte hittas`)
};

const en_page_not_found_heading = /** @type {(inputs: Page_Not_Found_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page not found`)
};

/**
* | output |
* | --- |
* | "Page not found" |
*
* @param {Page_Not_Found_HeadingInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const page_not_found_heading = /** @type {((inputs?: Page_Not_Found_HeadingInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Not_Found_HeadingInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_page_not_found_heading(inputs)
	return en_page_not_found_heading(inputs)
});